import { AppCheckbox, AppDialog } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { AlertCircle, BadgeCheck } from 'lucide-react'
import { useState } from 'react'
import { formatNumber } from '@/lib/format-utils'
import { cn } from '@/lib/utils'

interface IncentiveConfirmDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  period: string
  totalAmount: number
  onConfirm: () => Promise<void>
  isProcessing?: boolean
}

export function IncentiveConfirmDialog({
  open,
  onOpenChange,
  period,
  totalAmount,
  onConfirm,
  isProcessing = false,
}: IncentiveConfirmDialogProps) {
  const [confirmed, setConfirmed] = useState(false)

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      setConfirmed(false)
    }
    onOpenChange(newOpen)
  }

  const handleConfirm = async () => {
    try {
      await onConfirm()
    } catch {
      // エラー時もダイアログを閉じる（toastは useAcceptIncentive で表示される）
      onOpenChange(false)
    }
  }

  return (
    <AppDialog
      open={open}
      onOpenChange={handleOpenChange}
      title='インセンティブ確認'
      className='sm:max-w-137.5'
      footerOptions={[
        { label: 'キャンセル', onClick: () => handleOpenChange(false), variant: 'outline', disabled: isProcessing },
        {
          label: '実行',
          onClick: handleConfirm,
          variant: 'destructive',
          disabled: !confirmed || isProcessing,
          isPending: isProcessing,
        },
      ]}
    >
      <div className='py-4 space-y-14'>
        <div className='flex space-x-2 items-center'>
          <BadgeCheck className={cn('w-5 h-5', confirmed ? 'text-green-700' : 'text-gray-600')} />
          <p className='text-xl'>
            支払対象期間: {period}, 合計: {formatNumber(totalAmount)} 円
          </p>
        </div>
        <div>
          <div className='flex space-x-2 items-center'>
            <AlertCircle className='w-5 h-5 text-destructive' />
            <p className='text-m'>確認後は撤回することができません。実行しますか？</p>
          </div>
          <div className='flex justify-end'>
            <AppCheckbox
              id='confirm'
              checked={confirmed}
              onCheckedChange={(checked) => setConfirmed(checked === true)}
              label='確認しました'
            />
          </div>
        </div>
      </div>
    </AppDialog>
  )
}
